var _polygon, _polygon2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-10",
    cx: 244.62,
    cy: 328.65,
    rx: 201.17,
    ry: 116.15,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-10",
    d: "M315.38,458.19l154.24-89.05c3.38-1.95,3.38-5.11,0-7.06L186.1,199.1a13.54,13.54,0,0,0-12.24,0l-154.24,89c-3.38,2-3.38,5.12,0,7.07l283.53,163A13.52,13.52,0,0,0,315.38,458.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10",
    d: "M432,464.64a3.94,3.94,0,0,1-3.25-1.83L403.23,427a3.8,3.8,0,0,1-.5-4.07,3.54,3.54,0,0,1,3.23-1.87,5.48,5.48,0,0,1,1.17.14l63.68,15.14c3.06.73,3.12,2.89,3.07,3.53s-.48,2.76-3.62,3l-31.46,2-3.16,16.43a3.75,3.75,0,0,1-3.65,3.33Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--signal--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.47,107.61a1.67,1.67,0,0,0-1-1.33,5.25,5.25,0,0,0-4.76,0,1.7,1.7,0,0,0-1,1.33h0V261.78h6.73V107.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47,107.61c0-1-1.5-1.9-3.36-1.9s-3.36.85-3.36,1.9,1.5,1.91,3.36,1.91S314.47,108.66,314.47,107.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.43 141.43 286.53 116.07 279.93 119.88 286.53 131.31 330.43 156.68 330.43 141.43",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "330.43 141.43 286.53 116.07 279.93 119.88 286.53 131.31 330.43 156.68 330.43 141.43"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "286.53 116.07 289.83 114.16 333.79 139.56 330.43 141.43 286.53 116.07",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.53 116.07 289.83 114.16 333.79 139.56 330.43 141.43 286.53 116.07"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "333.79 154.81 330.43 156.68 330.43 141.43 333.79 139.56 333.79 154.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.79 154.81 330.43 156.68 330.43 141.43 333.79 139.56 333.79 154.81",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, 0.38, 0, 1, 288.9, 128.09)",
    style: {
      fontSize: "9.682530403137207px",
      fill: "#fff",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700,
      letterSpacing: "0.05002566269691848em"
    }
  }, "2nd St", /*#__PURE__*/React.createElement("tspan", {
    x: 34.9,
    y: 0,
    style: {
      letterSpacing: "0.04504999194480561em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.78,
    y: 0,
    style: {
      letterSpacing: "0.04989118510902353em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.14,
    y: 0,
    style: {
      letterSpacing: "0.045991335060070214em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.46,
    y: 0,
    style: {
      letterSpacing: "0.04989118510902353em"
    }
  }, "t")))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.17,338.13l-5.37-4.63s.21-16.56,5.05-29.88c6.82-18.73,21.27-22.83,25.68-20s4.41,8.79-6.39,18.28C451.76,307.52,442.5,320.17,439.17,338.13Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.17,338.13l-5.37-4.63s.21-16.56,5.05-29.88c6.82-18.73,21.27-22.83,25.68-20s4.41,8.79-6.39,18.28C451.76,307.52,442.5,320.17,439.17,338.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M438.48,330h.06a.44.44,0,0,0,.46-.42c1-18.57,12.16-37,21.88-43.38a.43.43,0,0,0,.13-.6.45.45,0,0,0-.61-.13c-9.91,6.51-21.24,25.21-22.28,44.06A.44.44,0,0,0,438.48,330Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,351.1c.85.73,3.06-.09,3.91-.45a9.14,9.14,0,0,0,3.71-2.89,8.7,8.7,0,0,0,1.76-5,19.49,19.49,0,0,0-.12-2.86l-.24-2.8a6.87,6.87,0,0,1,.13-2.75c.58-1.76,2.44-2.72,4.11-3.53,1.86-.9,3.85-2.17,4.27-4.35a7.84,7.84,0,0,0-1-4.94c-.79-1.53-1.8-2.94-2.47-4.51a5.41,5.41,0,0,1-.44-3.61,5.61,5.61,0,0,1,1.15-2,30.68,30.68,0,0,0,3.15-3.8A4.37,4.37,0,0,0,473,303a5.06,5.06,0,0,0-3.57-1.66,8.67,8.67,0,0,0-3.73.55c-3.84,1.25-6.62,5-10.58,5.73a36.18,36.18,0,0,1-4.66.22,5.63,5.63,0,0,0-4.16,1.8c-1.87,2.43,0,6.24-1.52,8.92-1.34,2.37-4,2.86-5.81,4.87a5.49,5.49,0,0,0-1.29,3.19,16.1,16.1,0,0,0,.31,5.87,39.48,39.48,0,0,0,2.09,5.64C440.16,338.2,454.88,351,455,351.1Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.21,344h0a.44.44,0,0,0,.51-.36c2.62-17.27,14.37-34.6,21.31-38.95a.45.45,0,0,0,.14-.6.44.44,0,0,0-.61-.14c-7.08,4.43-19.05,22.05-21.71,39.55A.44.44,0,0,0,446.21,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.72,324.22h.13a59.11,59.11,0,0,1,12.81.41.45.45,0,0,0,.51-.37.43.43,0,0,0-.37-.5,60.28,60.28,0,0,0-13.05-.42.44.44,0,0,0,0,.87Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-10",
    d: "M158.78,137.31l-5,2.89a5,5,0,0,0,0-.66v-1.45c0-2.58-1.81-3.62-4-2.33a7.87,7.87,0,0,0-2.41,2.31c-.36-3.24-2.91-4.45-6-2.66a13.34,13.34,0,0,0-6,10.47V148a5.8,5.8,0,0,0,.51,2.51l-4.15,2.4a5,5,0,0,0-2.24,3.88c0,1.43,1,2,2.24,1.3l27.09-15.64a5,5,0,0,0,2.24-3.88C161,137.18,160,136.6,158.78,137.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-10",
    d: "M179.55,150.19l-3.67,2.12a4.22,4.22,0,0,0,0-.49v-1.06c0-1.89-1.33-2.66-3-1.71a5.68,5.68,0,0,0-1.76,1.7c-.27-2.38-2.13-3.26-4.4-2a9.8,9.8,0,0,0-4.43,7.68v1.59a4.18,4.18,0,0,0,.37,1.84l-3,1.76a3.6,3.6,0,0,0-1.64,2.84c0,1.05.73,1.47,1.64.95L179.55,154a3.6,3.6,0,0,0,1.64-2.84C181.19,150.09,180.46,149.67,179.55,150.19Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.08,341.86c2.13,1.65,1.9,4-.68,5.47L314.21,428.85a11.4,11.4,0,0,1-10.27,0L34.12,273.06c-2.62-1.51-2.83-3.88-.61-5.52A11.42,11.42,0,0,0,29,276v6.79a11.3,11.3,0,0,0,5.14,8.9L303.92,447.5a11.35,11.35,0,0,0,10.28,0L455.39,366a11.31,11.31,0,0,0,5.13-8.89l0-6.8A11.48,11.48,0,0,0,456.08,341.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.4,341.41,185.57,185.62a11.43,11.43,0,0,0-10.27,0L34.12,267.14c-2.84,1.63-2.84,4.29,0,5.92L303.94,428.85a11.4,11.4,0,0,0,10.27,0L455.4,347.33C458.23,345.7,458.23,343,455.4,341.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.51,267.54A11.42,11.42,0,0,0,29,276v6.79a11.32,11.32,0,0,0,5.14,8.9L303.92,447.5a10.54,10.54,0,0,0,5.15,1.23V430.07a10.58,10.58,0,0,1-5.14-1.22L34.12,273.06C31.5,271.55,31.29,269.18,33.51,267.54Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.14,240.62c1.44-.83,1.44-2.18,0-3a5.72,5.72,0,0,0-5.22,0c-1.45.83-1.45,2.18,0,3A5.78,5.78,0,0,0,103.14,240.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.2,236.06l20.15-11.63c1.21-.69,1.27-1.79.14-2.44a4.69,4.69,0,0,0-4.22.08l-20.15,11.64c-1.2.69-1.26,1.78-.14,2.43A4.66,4.66,0,0,0,110.2,236.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.71,198.12c-2.42-1.4-5-.59-7.38.82l-132,76.14c-2.43,1.4-2.44,3.67,0,5.08l239.49,138.3a9.76,9.76,0,0,0,8.81,0l132-76.15c2.44-1.4,2.43-3.68,0-5.08Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.71,198.12c-2.42-1.4-5-.59-7.38.82l-132,76.14c-2.43,1.4-2.44,3.67,0,5.08l239.49,138.3a9.76,9.76,0,0,0,8.81,0l132-76.15c2.44-1.4,2.43-3.68,0-5.08Z",
    style: {
      fill: "#fff",
      opacity: 0.96
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.26,416.22,349,387.52l-8.35-2.41A101.22,101.22,0,0,0,262,394.7h0Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.55,382.57l74.27-42.88L382.11,311l-29.33,70.2Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.83,306.21l-29,72.69c-17.14-5.44-32.52-6.27-50.13-3.24l28-68.94,40.68-6.54Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,378.45l10.16-25-78.93-9.36-13.25,14.74,55,31.76A112.69,112.69,0,0,1,281.87,378.45Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.56 282.41 357.26 296.64 324.65 301.91 332.56 282.41",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.99,
    cy: 289.47,
    rx: 8.79,
    ry: 5.07,
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,307.21,188.36,292.74c-1.29,2.94-3.49,3.6-8.62,4.72l34.06,39L295,346Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.44,270.37l-9,21.75L188,285.54a12.65,12.65,0,0,0-4.76-3.07l7.61-19.4Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.09 276.92 313.56 300.43 252.76 293.22 262.31 269.71 323.09 276.92",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.69 270.33 210.98 212.19 193.54 256.32 311.69 270.33",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,296.77l37.19,42.53L191.56,354l-71.89-41.5L164,295.1A16.84,16.84,0,0,0,167.62,296.77Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.35 255.35 203.99 208.15 191.56 200.98 112.38 246.69 185.35 255.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,252.7,59,277.51l53.85,31.09,47.5-18.72c-.1-2.28,1-4.47,4.48-6.51,2.86-1.65,6.43-2.27,10.38-2.36l7.41-18.91Z",
    style: {
      fill: "#1F2937"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.69 253.74 197.69 238.93 220.56 241.64 220.56 256.44 197.69 253.74",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.56 241.64 225.27 228.45 225.27 244.78 220.56 256.44 220.56 241.64",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.27 228.45 202.89 225.75 197.69 238.93 220.56 241.64 225.27 228.45",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.69 253.74 197.69 238.93 220.56 241.64 220.56 256.44 197.69 253.74",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.56 241.64 225.27 228.45 225.27 244.78 220.56 256.44 220.56 241.64",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.27 228.45 202.89 225.75 197.69 238.93 220.56 241.64 225.27 228.45",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.68 285.36 212.68 278.73 235.56 281.43 235.56 288.07 212.68 285.36",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.56 281.43 239.64 270 239.64 278.16 235.56 288.07 235.56 281.43",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.64 270 217.25 267.3 212.68 278.73 235.56 281.43 239.64 270",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.68 285.36 212.68 278.73 235.56 281.43 235.56 288.07 212.68 285.36",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.56 281.43 239.64 270 239.64 278.16 235.56 288.07 235.56 281.43",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.64 270 217.25 267.3 212.68 278.73 235.56 281.43 239.64 270",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.73 372.67 256.73 357.87 279.6 360.57 279.6 375.38 256.73 372.67",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.6 360.57 284.32 347.39 284.32 363.72 279.6 375.38 279.6 360.57",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.32 347.39 261.94 344.69 256.73 357.87 279.6 360.57 284.32 347.39",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.73 372.67 256.73 357.87 279.6 360.57 279.6 375.38 256.73 372.67",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.6 360.57 284.32 347.39 284.32 363.72 279.6 375.38 279.6 360.57",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.32 347.39 261.94 344.69 256.73 357.87 279.6 360.57 284.32 347.39",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.34 260.4 256.34 254.95 267.92 256.32 267.92 261.77 256.34 260.4",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.92 256.32 270.3 249.64 270.3 255.87 267.92 261.77 267.92 256.32",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.3 249.64 258.97 248.28 256.34 254.95 267.92 256.32 270.3 249.64",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.34 260.4 256.34 254.95 267.92 256.32 267.92 261.77 256.34 260.4",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.92 256.32 270.3 249.64 270.3 255.87 267.92 261.77 267.92 256.32",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.3 249.64 258.97 248.28 256.34 254.95 267.92 256.32 270.3 249.64",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.96 234.68 171.96 226.74 188.8 228.73 188.8 236.67 171.96 234.68",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.8 228.73 192.27 219.03 192.27 228.09 188.8 236.67 188.8 228.73",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.27 219.03 175.79 217.04 171.96 226.74 188.8 228.73 192.27 219.03",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.96 234.68 171.96 226.74 188.8 228.73 188.8 236.67 171.96 234.68",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.8 228.73 192.27 219.03 192.27 228.09 188.8 236.67 188.8 228.73",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.27 219.03 175.79 217.04 171.96 226.74 188.8 228.73 192.27 219.03",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.35 291.3 258.35 284.23 273.37 286 273.37 293.08 258.35 291.3",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.37 286 276.46 277.35 276.46 285.43 273.37 293.08 273.37 286",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.46 277.35 261.77 275.58 258.35 284.23 273.37 286 276.46 277.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.35 291.3 258.35 284.23 273.37 286 273.37 293.08 258.35 291.3",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.37 286 276.46 277.35 276.46 285.43 273.37 293.08 273.37 286",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.46 277.35 261.77 275.58 258.35 284.23 273.37 286 276.46 277.35",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.23 282.86 190.23 275.58 205.68 277.4 205.68 284.69 190.23 282.86",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.68 277.4 208.86 268.5 208.86 276.81 205.68 284.69 205.68 277.4",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.86 268.5 193.75 266.68 190.23 275.58 205.68 277.4 208.86 268.5",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.23 282.86 190.23 275.58 205.68 277.4 205.68 284.69 190.23 282.86",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.68 277.4 208.86 268.5 208.86 276.81 205.68 284.69 205.68 277.4",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.86 268.5 193.75 266.68 190.23 275.58 205.68 277.4 208.86 268.5",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.78 293.54 277.78 286.46 292.8 288.24 292.8 295.32 277.78 293.54",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.8 288.24 295.89 279.59 295.89 287.66 292.8 295.32 292.8 288.24",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.89 279.59 281.2 277.81 277.78 286.46 292.8 288.24 295.89 279.59",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.78 293.54 277.78 286.46 292.8 288.24 292.8 295.32 277.78 293.54",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.8 288.24 295.89 279.59 295.89 287.66 292.8 295.32 292.8 288.24",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.89 279.59 281.2 277.81 277.78 286.46 292.8 288.24 295.89 279.59",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.21 295.78 297.21 288.7 312.22 290.48 312.22 297.55 297.21 295.78",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.22 290.48 315.32 281.82 315.32 289.9 312.22 297.55 312.22 290.48",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.32 281.82 300.63 280.05 297.21 288.7 312.22 290.48 315.32 281.82",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.21 295.78 297.21 288.7 312.22 290.48 312.22 297.55 297.21 295.78",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.22 290.48 315.32 281.82 315.32 289.9 312.22 297.55 312.22 290.48",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.32 281.82 300.63 280.05 297.21 288.7 312.22 290.48 315.32 281.82",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.51 272.17 117.51 265.09 132.53 266.87 132.53 273.95 117.51 272.17",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.53 266.87 135.62 258.22 135.62 266.29 132.53 273.95 132.53 266.87",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.62 258.22 120.93 256.44 117.51 265.09 132.53 266.87 135.62 258.22",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.51 272.17 117.51 265.09 132.53 266.87 132.53 273.95 117.51 272.17",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.53 266.87 135.62 258.22 135.62 266.29 132.53 273.95 132.53 266.87",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.62 258.22 120.93 256.44 117.51 265.09 132.53 266.87 135.62 258.22",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.94 274.41 136.94 267.33 151.96 269.11 151.96 276.18 136.94 274.41",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.96 269.11 155.05 260.45 155.05 268.53 151.96 276.18 151.96 269.11",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.05 260.45 140.36 258.68 136.94 267.33 151.96 269.11 155.05 260.45",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.94 274.41 136.94 267.33 151.96 269.11 151.96 276.18 136.94 274.41",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.96 269.11 155.05 260.45 155.05 268.53 151.96 276.18 151.96 269.11",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.05 260.45 140.36 258.68 136.94 267.33 151.96 269.11 155.05 260.45",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.37 276.64 156.37 269.57 171.38 271.35 171.38 278.42 156.37 276.64",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.38 271.35 174.48 262.69 174.48 270.77 171.38 278.42 171.38 271.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.48 262.69 159.78 260.92 156.37 269.57 171.38 271.35 174.48 262.69",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.37 276.64 156.37 269.57 171.38 271.35 171.38 278.42 156.37 276.64",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.38 271.35 174.48 262.69 174.48 270.77 171.38 278.42 171.38 271.35",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.48 262.69 159.78 260.92 156.37 269.57 171.38 271.35 174.48 262.69",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.25 249.46 350.25 245.25 362.98 246.75 362.98 250.96 350.25 249.46",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.25 249.46 350.25 245.25 362.98 246.75 362.98 250.96 350.25 249.46",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.98 246.75 364.84 241.29 364.84 246.41 362.98 250.96 362.98 246.75",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.98 246.75 364.84 241.29 364.84 246.41 362.98 250.96 362.98 246.75",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.84 241.29 352.4 239.8 350.25 245.25 362.98 246.75 364.84 241.29",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.84 241.29 352.4 239.8 350.25 245.25 362.98 246.75 364.84 241.29",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.99 338.53 259.99 331.45 275.01 333.23 275.01 340.31 259.99 338.53",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.01 333.23 278.1 324.57 278.1 332.65 275.01 340.31 275.01 333.23",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.1 324.57 263.41 322.8 259.99 331.45 275.01 333.23 278.1 324.57",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.99 338.53 259.99 331.45 275.01 333.23 275.01 340.31 259.99 338.53",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.01 333.23 278.1 324.57 278.1 332.65 275.01 340.31 275.01 333.23",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.1 324.57 263.41 322.8 259.99 331.45 275.01 333.23 278.1 324.57",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.73 340.76 278.73 333.69 293.75 335.46 293.75 342.54 278.73 340.76",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.75 335.46 296.85 326.81 296.85 334.88 293.75 342.54 293.75 335.46",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 326.81 282.15 325.04 278.73 333.69 293.75 335.46 296.85 326.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.73 340.76 278.73 333.69 293.75 335.46 293.75 342.54 278.73 340.76",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.75 335.46 296.85 326.81 296.85 334.88 293.75 342.54 293.75 335.46",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 326.81 282.15 325.04 278.73 333.69 293.75 335.46 296.85 326.81",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.55 362.24 212.55 355.17 227.57 356.94 227.57 364.02 212.55 362.24",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.57 356.94 230.66 348.29 230.66 356.37 227.57 364.02 227.57 356.94",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.66 348.29 215.97 346.51 212.55 355.17 227.57 356.94 230.66 348.29",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.55 362.24 212.55 355.17 227.57 356.94 227.57 364.02 212.55 362.24",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.57 356.94 230.66 348.29 230.66 356.37 227.57 364.02 227.57 356.94",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.66 348.29 215.97 346.51 212.55 355.17 227.57 356.94 230.66 348.29",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.29 364.48 231.29 357.4 246.31 359.18 246.31 366.25 231.29 364.48",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.31 359.18 249.41 350.52 249.41 358.6 246.31 366.25 246.31 359.18",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.41 350.52 234.71 348.75 231.29 357.4 246.31 359.18 249.41 350.52",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.29 364.48 231.29 357.4 246.31 359.18 246.31 366.25 231.29 364.48",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.31 359.18 249.41 350.52 249.41 358.6 246.31 366.25 246.31 359.18",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.41 350.52 234.71 348.75 231.29 357.4 246.31 359.18 249.41 350.52",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.25 328.65 345.25 321.57 360.26 323.35 360.26 330.42 345.25 328.65",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 323.35 363.36 314.69 363.36 322.77 360.26 330.42 360.26 323.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.36 314.69 348.66 312.92 345.25 321.57 360.26 323.35 363.36 314.69",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.25 328.65 345.25 321.57 360.26 323.35 360.26 330.42 345.25 328.65",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.26 323.35 363.36 314.69 363.36 322.77 360.26 330.42 360.26 323.35",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.36 314.69 348.66 312.92 345.25 321.57 360.26 323.35 363.36 314.69",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.36 343.23 339.36 336.15 354.37 337.93 354.37 345.01 339.36 343.23",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.37 337.93 357.47 329.27 357.47 337.35 354.37 345.01 354.37 337.93",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.47 329.27 342.77 327.5 339.36 336.15 354.37 337.93 357.47 329.27",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.36 343.23 339.36 336.15 354.37 337.93 354.37 345.01 339.36 343.23",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.37 337.93 357.47 329.27 357.47 337.35 354.37 345.01 354.37 337.93",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.47 329.27 342.77 327.5 339.36 336.15 354.37 337.93 357.47 329.27",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.46 357.81 333.46 350.73 348.48 352.51 348.48 359.59 333.46 357.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.48 352.51 351.58 343.85 351.58 351.93 348.48 359.59 348.48 352.51",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.58 343.85 336.88 342.08 333.46 350.73 348.48 352.51 351.58 343.85",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.46 357.81 333.46 350.73 348.48 352.51 348.48 359.59 333.46 357.81",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.48 352.51 351.58 343.85 351.58 351.93 348.48 359.59 348.48 352.51",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.58 343.85 336.88 342.08 333.46 350.73 348.48 352.51 351.58 343.85",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.57 372.39 327.57 365.32 342.59 367.09 342.59 374.17 327.57 372.39",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.59 367.09 345.69 358.44 345.69 366.51 342.59 374.17 342.59 367.09",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.69 358.44 330.99 356.66 327.57 365.32 342.59 367.09 345.69 358.44",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.57 372.39 327.57 365.32 342.59 367.09 342.59 374.17 327.57 372.39",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.59 367.09 345.69 358.44 345.69 366.51 342.59 374.17 342.59 367.09",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.69 358.44 330.99 356.66 327.57 365.32 342.59 367.09 345.69 358.44",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.75 325.68 319.75 318.61 334.77 320.38 334.77 327.46 319.75 325.68",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.77 320.38 337.87 311.73 337.87 319.8 334.77 327.46 334.77 320.38",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.87 311.73 323.17 309.95 319.75 318.61 334.77 320.38 337.87 311.73",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.75 325.68 319.75 318.61 334.77 320.38 334.77 327.46 319.75 325.68",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.77 320.38 337.87 311.73 337.87 319.8 334.77 327.46 334.77 320.38",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.87 311.73 323.17 309.95 319.75 318.61 334.77 320.38 337.87 311.73",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.86 340.26 313.86 333.19 328.88 334.96 328.88 342.04 313.86 340.26",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.88 334.96 331.98 326.31 331.98 334.39 328.88 342.04 328.88 334.96",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.98 326.31 317.28 324.54 313.86 333.19 328.88 334.96 331.98 326.31",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.86 340.26 313.86 333.19 328.88 334.96 328.88 342.04 313.86 340.26",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.88 334.96 331.98 326.31 331.98 334.39 328.88 342.04 328.88 334.96",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.98 326.31 317.28 324.54 313.86 333.19 328.88 334.96 331.98 326.31",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.97 354.85 307.97 347.77 322.99 349.55 322.99 356.62 307.97 354.85",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.99 349.55 326.09 340.89 326.09 348.97 322.99 356.62 322.99 349.55",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.09 340.89 311.39 339.12 307.97 347.77 322.99 349.55 326.09 340.89",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.97 354.85 307.97 347.77 322.99 349.55 322.99 356.62 307.97 354.85",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.99 349.55 326.09 340.89 326.09 348.97 322.99 356.62 322.99 349.55",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.09 340.89 311.39 339.12 307.97 347.77 322.99 349.55 326.09 340.89",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.08 369.43 302.08 362.35 317.1 364.13 317.1 371.2 302.08 369.43",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.1 364.13 320.2 355.47 320.2 363.55 317.1 371.2 317.1 364.13",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.2 355.47 305.5 353.7 302.08 362.35 317.1 364.13 320.2 355.47",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.08 369.43 302.08 362.35 317.1 364.13 317.1 371.2 302.08 369.43",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.1 364.13 320.2 355.47 320.2 363.55 317.1 371.2 317.1 364.13",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.2 355.47 305.5 353.7 302.08 362.35 317.1 364.13 320.2 355.47",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.13 352.35 370.13 346.79 381.95 348.19 381.95 353.75 370.13 352.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.95 348.19 384.38 341.38 384.38 347.73 381.95 353.75 381.95 348.19",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.38 341.38 372.82 339.98 370.13 346.79 381.95 348.19 384.38 341.38",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.13 352.35 370.13 346.79 381.95 348.19 381.95 353.75 370.13 352.35",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.95 348.19 384.38 341.38 384.38 347.73 381.95 353.75 381.95 348.19",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.38 341.38 372.82 339.98 370.13 346.79 381.95 348.19 384.38 341.38",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.23 368.75 364.23 363.18 376.04 364.58 376.04 370.14 364.23 368.75",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.04 364.58 378.48 357.77 378.48 364.12 376.04 370.14 376.04 364.58",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.48 357.77 366.92 356.37 364.23 363.18 376.04 364.58 378.48 357.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.23 368.75 364.23 363.18 376.04 364.58 376.04 370.14 364.23 368.75",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.04 364.58 378.48 357.77 378.48 364.12 376.04 370.14 376.04 364.58",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.48 357.77 366.92 356.37 364.23 363.18 376.04 364.58 378.48 357.77",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.38 335.6 237.38 309.08 256 311.28 256 337.79 237.38 335.6",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.38 335.6 237.38 309.08 256 311.28 256 337.79 237.38 335.6",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256 311.28 258.41 304.81 258.41 332.65 256 337.79 256 311.28",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256 311.28 258.41 304.81 258.41 332.65 256 337.79 256 311.28",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.41 304.81 240.22 302.63 237.38 309.08 256 311.28 258.41 304.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.41 304.81 240.22 302.63 237.38 309.08 256 311.28 258.41 304.81",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.26 246.47 143.26 215.11 153.99 216.31 153.99 247.66 143.26 246.47",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.26 246.47 143.26 215.11 153.99 216.31 153.99 247.66 143.26 246.47",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.99 216.31 156.4 209.84 156.4 242.52 153.99 247.66 153.99 216.31",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.99 216.31 156.4 209.84 156.4 242.52 153.99 247.66 153.99 216.31",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.4 209.84 146.1 208.66 143.26 215.11 153.99 216.31 156.4 209.84",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.4 209.84 146.1 208.66 143.26 215.11 153.99 216.31 156.4 209.84",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.19 245.37 155.19 217.72 160.87 218.33 160.87 245.99 155.19 245.37",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.19 245.37 155.19 217.72 160.87 218.33 160.87 245.99 155.19 245.37",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.87 218.33 161.76 215.5 161.76 244.28 160.87 245.99 160.87 218.33",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.87 218.33 161.76 215.5 161.76 244.28 160.87 245.99 160.87 218.33",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.76 215.5 156.44 214.89 155.19 217.72 160.87 218.33 161.76 215.5",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.76 215.5 156.44 214.89 155.19 217.72 160.87 218.33 161.76 215.5",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.12 332.95 215.12 306.43 233.74 308.62 233.74 335.14 215.12 332.95",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.12 332.95 215.12 306.43 233.74 308.62 233.74 335.14 215.12 332.95",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.74 308.62 236.16 302.16 236.16 330 233.74 335.14 233.74 308.62",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.74 308.62 236.16 302.16 236.16 330 233.74 335.14 233.74 308.62",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.16 302.16 217.97 299.98 215.12 306.43 233.74 308.62 236.16 302.16",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.16 302.16 217.97 299.98 215.12 306.43 233.74 308.62 236.16 302.16",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.21 249.46 166.21 241.52 183.04 243.51 183.04 251.45 166.21 249.46",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.04 243.51 186.52 233.81 186.52 242.87 183.04 251.45 183.04 243.51",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.52 233.81 170.04 231.82 166.21 241.52 183.04 243.51 186.52 233.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.21 249.46 166.21 241.52 183.04 243.51 183.04 251.45 166.21 249.46",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.04 243.51 186.52 233.81 186.52 242.87 183.04 251.45 183.04 243.51",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.52 233.81 170.04 231.82 166.21 241.52 183.04 243.51 186.52 233.81",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.52 306.35 139.46 313.31 129.8 307.77 142.48 300.45 151.52 306.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.52 306.35 139.46 313.31 129.8 307.77 142.48 300.45 151.52 306.35",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.8 313.51 129.8 307.77 139.46 313.31 139.46 319.08 129.8 313.51",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.8 313.51 129.8 307.77 139.46 313.31 139.46 319.08 129.8 313.51",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.52 306.35 151.52 312.12 139.46 319.08 139.46 313.31 151.52 306.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.52 306.35 151.52 312.12 139.46 319.08 139.46 313.31 151.52 306.35",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 314.3 152.94 321.26 143.29 315.72 155.97 308.41 165 314.3",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 314.3 152.94 321.26 143.29 315.72 155.97 308.41 165 314.3",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.29 321.46 143.29 315.72 152.94 321.26 152.94 327.03 143.29 321.46",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.29 321.46 143.29 315.72 152.94 321.26 152.94 327.03 143.29 321.46",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 314.3 165 320.07 152.94 327.03 152.94 321.26 165 314.3",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 314.3 165 320.07 152.94 327.03 152.94 321.26 165 314.3",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.76 322.18 166.7 329.13 157.04 323.6 169.72 316.28 178.76 322.18",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.76 322.18 166.7 329.13 157.04 323.6 169.72 316.28 178.76 322.18",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.04 329.33 157.04 323.6 166.7 329.13 166.7 334.91 157.04 329.33",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.04 329.33 157.04 323.6 166.7 329.13 166.7 334.91 157.04 329.33",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.76 322.18 178.76 327.95 166.7 334.91 166.7 329.13 178.76 322.18",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.76 322.18 178.76 327.95 166.7 334.91 166.7 329.13 178.76 322.18",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 325.73 186.22 332.69 176.56 327.15 189.24 319.84 198.28 325.73",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 325.73 186.22 332.69 176.56 327.15 189.24 319.84 198.28 325.73",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.56 340.96 176.56 327.15 186.22 332.69 186.22 346.54 176.56 340.96",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.56 340.96 176.56 327.15 186.22 332.69 186.22 346.54 176.56 340.96",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 325.73 198.28 339.57 186.22 346.54 186.22 332.69 198.28 325.73",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 325.73 198.28 339.57 186.22 346.54 186.22 332.69 198.28 325.73",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 293.26 113.1 298.15 103.44 292.62 117.14 287.37 126.17 293.26",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 293.26 113.1 298.15 103.44 292.62 117.14 287.37 126.17 293.26",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.44 298.35 103.44 292.62 113.1 298.15 113.1 303.93 103.44 298.35",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.44 298.35 103.44 292.62 113.1 298.15 113.1 303.93 103.44 298.35",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 293.26 126.17 299.03 113.1 303.93 113.1 298.15 126.17 293.26",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 293.26 126.17 299.03 113.1 303.93 113.1 298.15 126.17 293.26",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.13 285.26 134.05 290.16 124.39 284.62 138.09 279.37 147.13 285.26",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.13 285.26 134.05 290.16 124.39 284.62 138.09 279.37 147.13 285.26",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.39 290.36 124.39 284.62 134.05 290.16 134.05 295.93 124.39 290.36",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.39 290.36 124.39 284.62 134.05 290.16 134.05 295.93 124.39 290.36",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.13 285.26 147.13 291.04 134.05 295.93 134.05 290.16 147.13 285.26",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.13 285.26 147.13 291.04 134.05 295.93 134.05 290.16 147.13 285.26",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.48 256.56 226.48 248.2 250.92 251.08 250.92 259.44 226.48 256.56",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.48 256.56 226.48 248.2 250.92 251.08 250.92 259.44 226.48 256.56",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.92 251.08 256.08 236.63 256.08 246.67 250.92 259.44 250.92 251.08",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.92 251.08 256.08 236.63 256.08 246.67 250.92 259.44 250.92 251.08",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.08 236.63 232.18 233.75 226.48 248.2 250.92 251.08 256.08 236.63",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.08 236.63 232.18 233.75 226.48 248.2 250.92 251.08 256.08 236.63",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.62 246.12 229.62 205.34 248.76 207.59 248.76 248.37 229.62 246.12",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.62 246.12 229.62 205.34 248.76 207.59 248.76 248.37 229.62 246.12",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.76 207.59 252.94 195.89 252.94 238.02 248.76 248.37 248.76 207.59",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.76 207.59 252.94 195.89 252.94 238.02 248.76 248.37 248.76 207.59",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.94 195.89 234.24 193.64 229.62 205.34 248.76 207.59 252.94 195.89",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.94 195.89 234.24 193.64 229.62 205.34 248.76 207.59 252.94 195.89",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.59 202.71 235.59 180.48 246.03 181.71 246.03 203.94 235.59 202.71",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.59 202.71 235.59 180.48 246.03 181.71 246.03 203.94 235.59 202.71",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.03 181.71 248.31 175.33 248.31 198.3 246.03 203.94 246.03 181.71",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.03 181.71 248.31 175.33 248.31 198.3 246.03 203.94 246.03 181.71",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.31 175.33 238.1 174.1 235.59 180.48 246.03 181.71 248.31 175.33",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.31 175.33 238.1 174.1 235.59 180.48 246.03 181.71 248.31 175.33",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 315.22 346.28 250.96 365.43 253.21 365.43 317.47 346.28 315.22",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 315.22 346.28 250.96 365.43 253.21 365.43 317.47 346.28 315.22",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.43 253.21 368.23 245.02 368.23 310.63 365.43 317.47 365.43 253.21",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.43 253.21 368.23 245.02 368.23 310.63 365.43 317.47 365.43 253.21",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.23 245.02 349.52 242.77 346.28 250.96 365.43 253.21 368.23 245.02",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.23 245.02 349.52 242.77 346.28 250.96 365.43 253.21 368.23 245.02",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.26 335.72 377.26 276.22 393.95 278.07 393.95 337.58 377.26 335.72",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.26 335.72 377.26 276.22 393.95 278.07 393.95 337.58 377.26 335.72",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.95 278.07 397.71 268.02 397.71 329.58 393.95 337.58 393.95 278.07",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.95 278.07 397.71 268.02 397.71 329.58 393.95 337.58 393.95 278.07",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.71 268.02 381.68 266.17 377.26 276.22 393.95 278.07 397.71 268.02",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.71 268.02 381.68 266.17 377.26 276.22 393.95 278.07 397.71 268.02",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.83 334.02 395.83 280.28 404.67 281.23 404.67 334.97 395.83 334.02",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.83 334.02 395.83 280.28 404.67 281.23 404.67 334.97 395.83 334.02",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.67 281.23 406.04 276.82 406.04 332.33 404.67 334.97 404.67 281.23",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.67 281.23 406.04 276.82 406.04 332.33 404.67 334.97 404.67 281.23",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.04 276.82 397.77 275.88 395.83 280.28 404.67 281.23 406.04 276.82",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.04 276.82 397.77 275.88 395.83 280.28 404.67 281.23 406.04 276.82",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 270.17 90.91 284.24 90.91 291.89 66.53 277.82 66.53 270.17",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 270.17 90.91 284.24 90.91 291.89 66.53 277.82 66.53 270.17",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.28 277.82 115.28 270.17 90.91 284.24 90.91 291.89",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 270.17 90.91 284.24 90.91 291.89 115.28 277.82 115.28 270.17",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 270.17 90.91 256.1 66.53 270.17 90.91 284.24 115.28 270.17",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 270.17 90.91 256.1 66.53 270.17 90.91 284.24 115.28 270.17",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 268.99 90.91 283.06 90.91 280.72 66.53 266.65 66.53 268.99",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 268.99 90.91 283.06 90.91 280.72 66.53 266.65 66.53 268.99",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 283.06 115.28 268.99 115.28 266.65 90.91 280.72 90.91 283.06",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 283.06 115.28 268.99 115.28 266.65 90.91 280.72 90.91 283.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 266.65 90.91 252.58 66.53 266.65 90.91 280.72 115.28 266.65",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 266.65 90.91 252.58 66.53 266.65 90.91 280.72 115.28 266.65",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 265.21 90.91 279.28 90.91 276.94 66.53 262.87 66.53 265.21",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.53 265.21 90.91 279.28 90.91 276.94 66.53 262.87 66.53 265.21",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 279.28 115.28 265.21 115.28 262.87 90.91 276.94 90.91 279.28",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 279.28 115.28 265.21 115.28 262.87 90.91 276.94 90.91 279.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 262.87 90.91 248.8 66.53 262.87 90.91 276.94 115.28 262.87",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.28 262.87 90.91 248.8 66.53 262.87 90.91 276.94 115.28 262.87",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 274.3 90.91 215.22 70.6 203.5 70.6 262.57 90.91 274.3",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 215.22 111.22 203.5 111.22 262.57 90.91 274.3 90.91 215.22",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.22 203.5 90.91 191.77 70.6 203.5 90.91 215.22 111.22 203.5",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.22 203.5 90.91 191.77 70.6 203.5 90.91 215.22 111.22 203.5",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 274.3 90.91 215.22 70.6 203.5 70.6 262.57 90.91 274.3",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 212.88 90.91 163.12 74.66 153.52 74.66 203.5 90.91 212.88",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 212.88 90.91 163.12 107.15 153.52 107.15 203.5 90.91 212.88",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.15 153.52 90.91 144.25 74.66 153.52 90.91 163.12 107.15 153.52",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.15 153.52 90.91 144.25 74.66 153.52 90.91 163.12 107.15 153.52",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 212.88 90.91 163.12 74.66 153.52 74.66 203.5 90.91 212.88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 159.49 90.91 152.46 101.06 146.59 101.06 153.63 90.91 159.49",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.75 153.63 80.75 146.59 90.91 152.46 90.91 159.49 80.75 153.63",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.75 153.63 80.75 146.59 90.91 152.46 90.91 159.49 80.75 153.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.06 146.59 90.91 140.73 80.75 146.59 90.91 152.46 101.06 146.59",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.06 146.59 90.91 140.73 80.75 146.59 90.91 152.46 101.06 146.59",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 150.11 90.91 117.28 97 146.59 90.91 150.11",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.91 150.11 90.91 117.28 97 146.59 90.91 150.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.74 146.59 90.91 117.28 90.91 150.11 84.74 146.59",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.74 146.59 90.91 117.28 90.91 150.11 84.74 146.59",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,385.64a.68.68,0,0,1-.23-.05c-.13-.07-13.58-6.82-34.26-7.77s-30.54,3-30.64,3a.51.51,0,0,1-.66-.66L317.73,305l-71.1-8.29a.51.51,0,0,1-.41-.7l11.27-27.88L113.63,251.05a.49.49,0,0,1-.44-.56.51.51,0,0,1,.56-.45l144.53,17.19a.51.51,0,0,1,.37.25.51.51,0,0,1,0,.45l-11.28,27.89,71.1,8.29a.52.52,0,0,1,.38.24.53.53,0,0,1,0,.46l-30.24,74.71c3.09-1,12.74-3.5,30-2.71,20.91.95,34.54,7.8,34.68,7.87a.5.5,0,0,1,.22.68A.51.51,0,0,1,353.11,385.64Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locators--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pin--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4,72.31v-3A37.43,37.43,0,0,1,75.3,58h0C78.39,48.45,84.9,39.31,92.43,35c4.79-2.77,9.16-3.11,12.51-1.45l-6.59-3.79a9.75,9.75,0,0,0-5.48-1.61,7.19,7.19,0,0,0-.92.05c-.32,0-.64.06-1,.11a8.05,8.05,0,0,0-1,.18,9.94,9.94,0,0,0-1,.27,16.83,16.83,0,0,0-2.07.76c-.35.15-.7.33-1.06.5s-.72.38-1.07.58C74.3,36.64,65.79,52,65.79,65v3c0,12.93,17.39,27,17.39,27l7,4a3,3,0,0,1-.35-.27C84.68,93.82,73.4,82.26,73.4,72.31ZM94.16,45.12a7.88,7.88,0,0,1,.12,1c0,.12,0,.23,0,.35a5.72,5.72,0,0,1,0,.59c0,6.06-4.25,13.44-9.51,16.47l-.57.31c-.19.1-.38.18-.56.26l-.55.23-.06,0c.82,4.64,4.68,6.26,9.36,3.58,5.25-3,9.5-10.42,9.5-16.48C101.93,46.06,98.58,43.51,94.16,45.12Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,72.31v-3A37.43,37.43,0,0,1,75.3,58h0C78.39,48.45,84.9,39.31,92.43,35c4.79-2.77,9.16-3.11,12.51-1.45l-6.59-3.79a9.75,9.75,0,0,0-5.48-1.61,7.19,7.19,0,0,0-.92.05c-.32,0-.64.06-1,.11a8.05,8.05,0,0,0-1,.18,9.94,9.94,0,0,0-1,.27,16.83,16.83,0,0,0-2.07.76c-.35.15-.7.33-1.06.5s-.72.38-1.07.58C74.3,36.64,65.79,52,65.79,65v3c0,12.93,17.39,27,17.39,27l7,4a3,3,0,0,1-.35-.27C84.68,93.82,73.4,82.26,73.4,72.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,45.12a7.88,7.88,0,0,1,.12,1c0,.12,0,.23,0,.35a5.72,5.72,0,0,1,0,.59c0,6.06-4.25,13.44-9.51,16.47l-.57.31c-.19.1-.38.18-.56.26l-.55.23-.06,0c.82,4.64,4.68,6.26,9.36,3.58,5.25-3,9.5-10.42,9.5-16.48C101.93,46.06,98.58,43.51,94.16,45.12Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,47.4c0-12.93-8.51-18.5-19-12.43s-19,21.46-19,34.39v3c0,10,11.28,21.51,16.47,26.3a2.56,2.56,0,0,0,4-.76c4.48-9.17,17.53-36.8,17.53-47.51Zm-19,20.51c-5.25,3-9.51.58-9.51-5.49S87.17,49,92.42,46s9.51-.58,9.51,5.49S97.67,64.88,92.42,67.91Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,47.4c0-12.93-8.51-18.5-19-12.43s-19,21.46-19,34.39v3c0,10,11.28,21.51,16.47,26.3a2.56,2.56,0,0,0,4-.76c4.48-9.17,17.53-36.8,17.53-47.51Zm-19,20.51c-5.25,3-9.51.58-9.51-5.49S87.17,49,92.42,46s9.51-.58,9.51,5.49S97.67,64.88,92.42,67.91Z",
    style: {
      fill: "#1F2937"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pin--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.94,153.65v-1a12.26,12.26,0,0,1,.63-3.72h0a13.89,13.89,0,0,1,5.63-7.57,4.3,4.3,0,0,1,4.11-.48l-2.17-1.25a3.19,3.19,0,0,0-1.79-.52H243l-.31,0a1.91,1.91,0,0,0-.33.06l-.32.08a4.73,4.73,0,0,0-.68.26l-.35.16-.36.19c-3.45,2-6.25,7-6.25,11.3v1c0,4.25,5.72,8.87,5.72,8.87l2.31,1.31-.11-.09C240.65,160.71,236.94,156.92,236.94,153.65Zm6.83-8.94a3.31,3.31,0,0,1,0,.33v.11a1.34,1.34,0,0,1,0,.2,6.91,6.91,0,0,1-3.13,5.41l-.18.1-.19.09-.18.07h0c.26,1.52,1.53,2.05,3.07,1.17a6.92,6.92,0,0,0,3.12-5.41C246.32,145,245.22,144.18,243.77,144.71Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,153.65v-1a12.26,12.26,0,0,1,.63-3.72h0a13.89,13.89,0,0,1,5.63-7.57,4.3,4.3,0,0,1,4.11-.48l-2.17-1.25a3.19,3.19,0,0,0-1.79-.52H243l-.31,0a1.91,1.91,0,0,0-.33.06l-.32.08a4.73,4.73,0,0,0-.68.26l-.35.16-.36.19c-3.45,2-6.25,7-6.25,11.3v1c0,4.25,5.72,8.87,5.72,8.87l2.31,1.31-.11-.09C240.65,160.71,236.94,156.92,236.94,153.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,144.71a3.31,3.31,0,0,1,0,.33s0,.07,0,.11v.2a6.9,6.9,0,0,1-3.12,5.41l-.19.1-.18.09-.19.07h0c.27,1.52,1.54,2.05,3.07,1.17a6.9,6.9,0,0,0,3.12-5.41C246.29,145,245.2,144.18,243.74,144.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,145.46c0-4.25-2.8-6.08-6.25-4.09S237,148.43,237,152.68v1c0,3.27,3.7,7.06,5.41,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8A6.91,6.91,0,0,1,243.2,145c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,243.2,152.2Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,145.46c0-4.25-2.8-6.08-6.25-4.09S237,148.43,237,152.68v1c0,3.27,3.7,7.06,5.41,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8A6.91,6.91,0,0,1,243.2,145c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,243.2,152.2Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.45,145.46c0-4.25-2.8-6.08-6.25-4.09S237,148.43,237,152.68v1c0,3.27,3.7,7.06,5.41,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8A6.91,6.91,0,0,1,243.2,145c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,243.2,152.2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pin--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.41,219v-1a12.26,12.26,0,0,1,.63-3.72h0a13.89,13.89,0,0,1,5.63-7.57,4.3,4.3,0,0,1,4.11-.48L361.61,205a3.22,3.22,0,0,0-1.8-.52h-.3l-.32,0-.32.06-.33.08a5.85,5.85,0,0,0-.68.26l-.34.16-.36.19c-3.45,2-6.25,7.05-6.25,11.3v1c0,4.25,5.72,8.87,5.72,8.87l2.31,1.31-.11-.09C357.12,226,353.41,222.22,353.41,219Zm6.83-8.94a3.31,3.31,0,0,1,0,.33v.11a1.34,1.34,0,0,1,0,.2,6.91,6.91,0,0,1-3.13,5.41l-.18.1-.19.09-.18.07h0c.27,1.52,1.54,2,3.08,1.17a6.92,6.92,0,0,0,3.12-5.41C362.79,210.32,361.69,209.48,360.24,210Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.41,219v-1a12.26,12.26,0,0,1,.63-3.72h0a13.89,13.89,0,0,1,5.63-7.57,4.3,4.3,0,0,1,4.11-.48L361.61,205a3.22,3.22,0,0,0-1.8-.52h-.3l-.32,0-.32.06-.33.08a5.85,5.85,0,0,0-.68.26l-.34.16-.36.19c-3.45,2-6.25,7.05-6.25,11.3v1c0,4.25,5.72,8.87,5.72,8.87l2.31,1.31-.11-.09C357.12,226,353.41,222.22,353.41,219Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.21,210a3.31,3.31,0,0,1,0,.33s0,.07,0,.11v.2a6.9,6.9,0,0,1-3.12,5.41l-.19.1-.18.09-.19.07h0c.27,1.52,1.54,2,3.07,1.17a6.9,6.9,0,0,0,3.12-5.41C362.76,210.32,361.66,209.48,360.21,210Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,210.76c0-4.25-2.8-6.08-6.25-4.09s-6.26,7.06-6.26,11.31v1c0,3.27,3.71,7.06,5.42,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8a6.91,6.91,0,0,1,3.13-5.42c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,359.67,217.5Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,210.76c0-4.25-2.8-6.08-6.25-4.09s-6.26,7.06-6.26,11.31v1c0,3.27,3.71,7.06,5.42,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8a6.91,6.91,0,0,1,3.13-5.42c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,359.67,217.5Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.92,210.76c0-4.25-2.8-6.08-6.25-4.09s-6.26,7.06-6.26,11.31v1c0,3.27,3.71,7.06,5.42,8.64a.84.84,0,0,0,1.33-.25c1.47-3,5.76-12.09,5.76-15.61Zm-6.25,6.74c-1.73,1-3.13.19-3.13-1.8a6.91,6.91,0,0,1,3.13-5.42c1.72-1,3.12-.19,3.12,1.81A6.91,6.91,0,0,1,359.67,217.5Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.89,439.42h0v-8.77l-65.53-15.07v8.76h0a1.25,1.25,0,0,0,.3.72l25.51,35.78c.63.88,1.31.73,1.51-.33l3.23-16.79a2.65,2.65,0,0,1,2.32-2l31.82-2C470.61,439.61,470.88,439.53,470.89,439.42Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.89,439.42h0v-8.77l-65.53-15.07v8.76h0a1.25,1.25,0,0,0,.3.72l25.51,35.78c.63.88,1.31.73,1.51-.33l3.23-16.79a2.65,2.65,0,0,1,2.32-2l31.82-2C470.61,439.61,470.88,439.53,470.89,439.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.74,461.35c.43.2.81-.08.95-.83l3.23-16.79a2.54,2.54,0,0,1,.53-1.08V430.32l-4.71,6.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.69,451.74,435.92,435a2.65,2.65,0,0,1,2.32-2l31.83-2c1.07-.07,1.09-.33,0-.58l-63.68-15.14c-1.05-.25-1.39.26-.76,1.14l25.51,35.78C431.81,453,432.49,452.8,432.69,451.74Z",
    style: {
      fill: "#1F2937"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.97504a3735fede2f34f07020bacde202.svg";
export { ForwardRef as ReactComponent };